/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import {clsx} from 'clsx';
import {Button, Typography} from 'onboarding-components';
import * as React from 'react';

import {SvgIconReact} from 'common/components/svg-icon';

import styles from '../index.module.styl';
import {track, TrackingEvent, TrackingProperty} from '../tracking';
import {SetupGuideContext, Step} from '../types';
import {ScrollableLink} from './scroll-manager';

const StepIndicator = ({isCompleted, moniker, children, step: targetStep}) => {
  const {step} = React.useContext(SetupGuideContext);

  return (
    <ScrollableLink
      className={clsx({[styles.completed]: isCompleted}, styles.indicator)}
      targetStep={targetStep}
      onClick={() => {
        track(TrackingEvent.StepClick, {[TrackingProperty.Source]: `SideNav`, [TrackingProperty.StepName]: targetStep});
      }}
    >
      {isCompleted ? (
        <div className={clsx(styles.moniker, styles.completed, {[styles.current]: step === targetStep})}>
          <SvgIconReact icon='checkmark' />
        </div>
      ) : (
        <div className={clsx(styles.moniker, {[styles.current]: step === targetStep})}>
          <Typography variant='eyebrowSm' weight='bold' style={{letterSpacing: 0, lineHeight: `100%`}}>
            {moniker}
          </Typography>
        </div>
      )}
      <Typography variant='bodySm'>{children}</Typography>
    </ScrollableLink>
  );
};

export const SideNav = ({onClose}) => {
  const {completed} = React.useContext(SetupGuideContext);

  return (
    <div className={styles.nav}>
      <div>
        <Typography variant='headingMd' style={{margin: 0}}>{`Setup Guide`}</Typography>
        <Typography variant='bodySm' className={styles.subtitle}>{`Up and running in 20 minutes`}</Typography>
        <div className={styles.indicatorGroup}>
          {/* Replace with components */}
          <StepIndicator isCompleted={completed[Step.Welcome]} moniker={1} step={Step.Welcome}>
            Welcome
          </StepIndicator>
          <StepIndicator isCompleted={completed[Step.Events]} moniker={2} step={Step.Events}>
            Personalize your setup
          </StepIndicator>
          <StepIndicator isCompleted={completed[Step.Implement]} moniker={3} step={Step.Implement}>
            Connect your data
          </StepIndicator>
          <StepIndicator isCompleted={false} moniker={4} step={Step.Explore}>
            Explore product insights
          </StepIndicator>
        </div>
      </div>
      <Button onClick={onClose} variant='inline' color='dark' className={styles.footerButton}>
        Skip and continue later
      </Button>
    </div>
  );
};
